import axios from '../utils/auth';

const saveJob = (inputs) => {
    return axios().post("job/create", inputs);
}

const jobList = (inputs) => {
    return axios().post("job/list", inputs);
}
const jobDetails = (id) => {
    return axios().get("job/details/" + id);
}
const jobPublic = (params) => {
    return axios().get("job/view/" + params.id + "?activeLang=" + params.currentLang);
}
const jobDelete = (id) => {
    return axios().get("job/delete/" + id);
}
const allJobs = (inputs) => {
    return axios().post("job/all", inputs);
}

const authService = {
    saveJob,
    jobList,
    jobDetails,
    jobDelete,
    allJobs,
    jobPublic
};

export default authService;
